module.exports = __webpack_public_path__ + "static/img/inner_box_label_0.bf76e1d6.png";